import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
export function Video({ mirrored = false, fit = 'cover', srcObject, ...props }) {
    const [video, setVideo] = useState(null);
    const videoTrack = useMemo(() => srcObject?.getVideoTracks()[0], [srcObject]);
    useEffect(() => {
        if (!video || !videoTrack) {
            return () => { };
        }
        video.srcObject = new MediaStream([videoTrack]);
    }, [videoTrack, video]);
    return (_jsx(VideoRoot, { ...props, ref: setVideo, "$mirrored": mirrored, "$fit": fit }));
}
const VideoRoot = styled.video `
    --Video_ScaleX: ${({ $mirrored }) => ($mirrored ? -1 : 1)};

    object-fit: ${({ $fit }) => $fit};
    transform: scaleX(var(--Video_ScaleX, 1));
    border-radius: 1rem;
    display: block;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;
